import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=14bd70c9"
import script from "./VTag.vue?vue&type=script&lang=js"
export * from "./VTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports